<template>
  <div id="news">
    <!--banner-->
    <div class="swiper-container swiper-no-swiping common" id="banner">
      <div class="swiper-wrapper">
        <div class="swiper-slide swiper-slide-banner" style="background-image: url('https://img.deepbaytech.com/fn/news.png')">
          <div class="swiper-slide-title">
            <div style="font-size: 48px; padding-left: 20px; margin: 0 auto;">新闻中心</div>
            <div style="font-size: 20px; padding-left: 20px; margin: 12px auto 18px auto">
              最新动态发展，最热新闻资讯，精彩内容尽收眼底。</div>
          </div>
        </div>
      </div>
    </div>
    <!--news tab -->
    <div class="tabNew">
      <div class="tabNew-container">
        <ul class="tabNew-header">
          <li v-for="(news,index) in newslist" :key="index" :class="{'active-tabNew' :isShow==index}" @click="tabHandle(index)">
            {{news.informationCategoryName}}</li>
        </ul>
        <hr />
        <div class="mainNews">
          <div class="mainNews-list">
            <ul v-for="(news,index) in newslist" :key="index" :class="{'active-mainNews': isShow !== index}" class="mainNews-list-1">
              <li v-for="(latestNew,index) in news.latestNews" :key="index" class="mainNews-list-li" @click="routerNewsContent(latestNew.id)">
                <div class="mainNews-list-li-img">
                  <img :src="latestNew.informationPreviewImgs[0]" alt="">
                </div>
                <div class="mainNews-list-li-text">
                  <p class="mainNews-list-li-text-title">{{latestNew.informationTitle}}</p>
                  <p class="mainNews-list-li-text-p">{{latestNew.informationIntroduce}}</p>
                  <p class="mainNews-list-li-text-time">{{latestNew.publishTime.slice(0,10)}}</p>
                </div>
              </li>
            </ul>
            <div class="mainNews-list-2">
              <p class="mainNews-hot">热门推荐</p>
              <hr />
              <ul class="mainNews-hot-list">
                <li v-for="(hot,index) in newhot" :key="index" @click="routerNewsContent(hot.informationId)">{{hot.informationIntroduce}}</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--tab-->
    <!--      <div class="tab-container">-->
    <!--        <div class="tab">-->
    <!--          <div class="tab-item">全部动态</div>-->
    <!--          <div class="tab-item">行业新闻</div>-->
    <!--          <div class="tab-item">最新技术</div>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--&lt;!&ndash;      container&ndash;&gt;-->
    <!--      <div class="container">-->
    <!--<div class="container-item">-->
    <!--  <img src="">-->
    <!--  <p class="container-item">对话式人工智能</p>-->
    <!--  <p>实时自然语言理解将改变我们与智能机器和应用程序的交互方式。高质量人机对话应响应迅速、智能且声音自然这是因为人类对话极其复杂，每个语句都建立在既定语境和先前的交互之上。从“内涵笑话”到特。</p>-->
    <!--<p>2020-01-20</p>-->
    <!--</div>-->
    <!--      </div>-->
    <!-- 服务咨询 -->
    <Consultation class="common" />
    <!-- 尾部 -->
    <Footer class="common" />
  </div>
</template>
<script>
import Swiper from 'swiper'
import 'swiper/dist/css/swiper.min.css'
import 'swiper/dist/js/swiper.min.js'
import Consultation from "./../../components/Consultation/Consultation"
import Footer from "./../../components/Footer/Footer"
import { getNewsCasual, getNewsHot } from './../../api/index'
export default {
  name: 'News',
  components: {
    Consultation,
    Footer
  },
  data () {
    return {
      active: '',
      isShow: 0,
      result: '',
      newslist: '',
      hot: '',
      hotdata: '',
      newhot: '',
      activeName: 'second'
    }
  },
  mounted () {
    this.getNewsFuc()
    this.getHotFuc()
    new Swiper('#banner', {
      pagination: {
        el: '.swiper-pagination',
        type: 'fraction',
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    })
  },
  methods: {
    tabHandle (flag) {
      this.isShow = flag
    },
    routerNewsContent (id) {
      this.$router.push({
        path: `/newsContent/${id}`,
      })
    },
    async getNewsFuc () {
      this.result = await getNewsCasual()
      console.log(this.result)
      this.newslist = this.result.data
      console.log(this.newslist)
      for (var i = 0; i < 1; i++) {
        this.newhot = this.newslist[i].latestNews
        console.log(this.newhot)
      }
    },
    async getHotFuc () {
      this.hot = await getNewsHot()
      this.hotdata = this.hot.data
      console.log(this.hotdata)
    }
  }
}
</script>
<style scoped>
hr {
  border: none;
  height: 1px;
  background-color: #e5e5e5;
}
.common {
  min-width: 1180px;
}
.swiper-container {
  height: 480px;
}
.swiper-slide-banner {
  width: 100%;
  height: 480px !important;
}
.swiper-slide {
  position: relative;
  background-size: cover;
}
.swiper-slide-title {
  color: #fff;
  width: 1180px;
  margin: 0 auto;
  padding-top: 170px;
}
.tabNew,
.mainNews {
  width: 100%;
  height: auto;
}
.tabNew-header,
.mainNews-list {
  margin: 0 auto;
  width: 100%;
  max-width: 1180px;
  display: flex;
}
.mainNews-list-1 {
  width: 75%;
}
.mainNews-list-2 {
  width: 25%;
  margin-top: 6px;
  height: 390px;
  overflow: hidden;
}
.tabNew-header li {
  /* list-style: none; */
  display: flex;
  height: 80px;
  cursor: pointer;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  color: #666666;
  margin-right: 80px;
}
.mainNews {
  margin-top: 48px;
}
.active-tabNew {
  border-bottom: 2px solid #fd6622;
  color: #fd6622 !important;
}
.active-mainNews {
  display: none;
}
.mainNews-list-li {
  display: flex;
  width: 90%;
  margin-bottom: 18px;
  cursor: pointer;
  padding: 15px;
}
.mainNews-list-li:hover {
  box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.08);
}
.mainNews-list-li-img {
  width: 299px;
  height: 180px;
  border: 1px solid #eeeeee;
}
.mainNews-list-li-img img {
  width: 100%;
  height: 100%;
}
.mainNews-list-li-text {
  margin-left: 21px;
  margin-top: 14px;
  width: 440px;
}
.mainNews-list-li-text-title {
  color: #333333;
  font-size: 18px;
}
.mainNews-list-li-text-p {
  color: #666666;
  font-size: 14px;
  margin-top: 18px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  line-height: 22px;
}
.mainNews-list-li-text-time {
  color: #999999;
  font-size: 14px;
  margin-top: 30px;
}
.mainNews-hot {
  color: #333333;
  font-size: 16px;
  margin-bottom: 20px;
  margin-left: 12px;
}
.mainNews-hot-list {
  margin-left: 16px;
  padding-bottom: 50px;
}
.mainNews-hot-list li {
  margin-top: 20px;
  color: #666666;
  font-size: 14px;
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.mainNews-hot-list li:hover {
  color: #fd6622;
}
.tab-container {
  border-bottom: 1px solid #eaeaea;
}
.tab {
  width: 1180px;
  margin: auto;
  padding: 26px 0 26px 0;
}
.tab-item {
  /*display: inline-block;*/
  margin-right: 80px;
  line-height: 28px;
  color: #666666;
  font-size: 20px;
}
.tab-item:hover {
  color: #77ba00;
  border-bottom: 3px solid #77ba00;
}
.container {
  width: 1180px;
  margin: auto;
  background: #ffffff;
  padding-top: 28px;
}
</style>
